import {
  ICountryAsset,
  ICountryAssetLite,
  ICurrency,
} from "models/Assets/ICountryAsset";

export const filterCountryByCountryCode = (
  allCountries: ICountryAssetLite[],
  countryCode: string
): ICountryAssetLite => {
  return (
    allCountries &&
    allCountries.filter((c) => c.abbreviation === countryCode)[0]
  );
};

export const filterCurrencyByCurrencyId = (
  country: ICountryAssetLite | ICountryAsset,
  currencyId: number | string = country?.default_currency
): ICurrency => {
  const currency =
    country &&
    country.currencies.filter((cur) => cur.id === Number(currencyId))[0];

  if (currency)
    currency.isDefault = Boolean(
      country && country.default_currency === currency.id
    );

  return currency;
};
